import config from './configs';
import StoreRegistrationService from './core/StoreRegistration';
import StoreService from './core/Store';

const storeRegistrationService = new StoreRegistrationService(config.services.storeRegistration.endpointName);
const storeService = new StoreService(config.services.store.endpointName);

export { storeRegistrationService, storeService };